module.exports = __webpack_public_path__ + "static/media/Board of Studies_2024-25.55daec26.pdf";